// extracted by mini-css-extract-plugin
export default {"container":"MapView_container__cgYJ1","img":"MapView_img__9i3m6","polygon":"MapView_polygon__QNAZr","buttonContainer":"MapView_buttonContainer__+UsTg"};